<div class="row">
  <div class="col-sm-12">
    <app-card [cardOptionBtnIcon]="'feather icon-plus'"
              [cardOptionBtnValue]="'global.actions.add'|translate"
              [cardOptionBtn]="true"
              [cardRouterLink]="'/back-office/invoice-layout/add'"
              [title]="'global.overview'|translate">
      <app-grid [grid]="grid"></app-grid>
    </app-card>
  </div>
</div>

<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Layout'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}} : <span [innerHTML]="layoutName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="delete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
